export default __webpack_public_path__ + "static/media/Breeches of Nebthu.2ba01ab7.jpg";